import {Component, inject, Input, ChangeDetectionStrategy} from '@angular/core';
import {Challenge} from '@/app/core/models/p-place/pixel';
import {TranslateDynamicService} from '@services/translate-dynamic.service';
import {NgClass} from '@angular/common';
import {ChallengeRewardsPipe} from '@/app/shared/pipes/challenge-rewards.pipe';

@Component({
	selector: 'peps-challenge-card',
	imports: [
		NgClass,
		ChallengeRewardsPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './challenge-card.component.html',
})
export class ChallengeCardComponent {

	protected readonly translateDynamicService = inject(TranslateDynamicService);

	@Input() challenge: Challenge | undefined;
	@Input() isUserHasCompleted: boolean = false;

	getRewardImage(challenge: Challenge, isUserHasCompleted: boolean): string {

		// On cherche une récompense de type BADGE dans le tableau
		const badgeReward = challenge.rewards?.find(r => r.type === 'BADGE');

		// Si l'utilisateur a complété le défi et qu'une récompense BADGE existe
		if (isUserHasCompleted && badgeReward) {
			return `assets/images/badges/${badgeReward.value}.svg`;
		}

		// Sinon, on affiche le badge "non complété" selon le type de défi
		switch (challenge.type) {
			case 'PIXEL':
				return 'assets/images/badges/badge_pixel_uncompleted.svg';
			case 'CONNECTION':
				return 'assets/images/badges/badge_connection_uncompleted.svg';
		}
	}

	hasBadgeReward(challenge: Challenge): boolean {
		return challenge.rewards?.some(r => r.type === 'BADGE');
	}

}
